@if (icon) {
    <div class="media">
        <ng-content class="media-object" select="fui-icon"></ng-content>
    </div>
}
<div class="label">
    <div class="label-title" id="label">
        {{ title | translate }}
    </div>
</div>
@if (toggle) {
    <div class="toggle" select="fui-mark-toggle">
        <ng-content></ng-content>
    </div>
}
